import { useState, useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import TrustBar from "@/components/landing/TrustBar";
import MethodSection from "@/components/landing/MethodSection";
import WhySection from "@/components/landing/WhySection";
import OffersSection from "@/components/landing/OffersSection";
import OutcomesSection from "@/components/landing/OutcomesSection";
import VictorySection from "@/components/landing/VictorySection";
import CommunitySection from "@/components/landing/CommunitySection";
import GoogleReviewsWidget from "@/components/landing/GoogleReviewsWidget";
import CoachSection from "@/components/landing/CoachSection";
import FAQSection from "@/components/landing/FAQSection";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress(total > 0 ? window.scrollY / total : 0);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div data-testid="landing-page" className="bg-[#050505] min-h-screen grain">
      <div className="scroll-progress" style={{ transform: `scaleX(${scrollProgress})` }} />
      <Navbar />
      <HeroSection />
      <TrustBar />
      <MethodSection />
      <WhySection />
      <OffersSection />
      <OutcomesSection />
      <VictorySection />
      <CommunitySection />
      <GoogleReviewsWidget />
      <CoachSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
